import { configureStore } from '@reduxjs/toolkit';
import roomReducer from './features/roomReducer';

export const store = configureStore({
  reducer: {
    room: roomReducer,
  }
});

export default store;